import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AddProject } from '../../project.model';
import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-add-project-editor',
  templateUrl: './add-project-editor.component.html',
  styleUrls: ['./add-project-editor.component.scss']
})
export class AddProjectEditorComponent {

  addProjectEnabled = false;
  project = new AddProject({});
  formGroup = new FormGroup({});

  @Output() projectAdded = new EventEmitter<number>();

  constructor(
    private http: HttpService,
    public translationService: TranslationService
  ) {
    this.formGroup.addControl('name', new FormControl('', [Validators.required]));
    this.formGroup.addControl('startDate', new FormControl('', []));
    this.formGroup.addControl('endDate', new FormControl('', []));
    this.formGroup.valueChanges.subscribe(formValues => {
      this.project.name = formValues.name;
      if (formValues.startDate != null) {
        this.project.startDate = formValues.startDate;
      }
      if (formValues.endDate != null) {
        this.project.endDate = formValues.endDate;
      }
      this.addProjectEnabled = this.formGroup.valid;
    });
  }

  public addProject() {

    if (!this.addProjectEnabled) {
      return;
    }

    this.http.postWithContext<number>(environment.erpProjectEndpoint + '/addProject', this.project).subscribe(newProjectId => {

      console.log('response is', newProjectId);
      this.projectAdded.next(newProjectId)

    }, error => {
      console.log('error is', error);
    });
  }
}
